import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { catchError, combineLatest, mergeMap, of, startWith } from 'rxjs';
import { ReportType } from '@interfaces/schema';
import { selectReportViewReportType } from '../view.selectors';
import { ReportViewSearchActions } from './search.actions';
import { selectReportViewSearchKeyword } from './search.selectors';
import { ReportViewSearchService } from './search.service';

/**
 * @description Report View Search Effects.
 * @exports
 * @class ReportViewSearchEffects
 */
@Injectable()
export class ReportViewSearchEffects extends ReportViewSearchService {
  private readonly actions = inject(Actions);
  private readonly store = inject(Store);

  readonly onFetchCategoryAndTrait = createEffect(
    () => {
      return this.actions.pipe(
        ofType(ReportViewSearchActions.fetchCategoryAndTrait),
        concatLatestFrom(() => [
          this.store.select(selectReportViewReportType),
          this.store.select(selectReportViewSearchKeyword)
        ]),
        mergeMap(([, reportType, keyword]) => {
          return combineLatest([
            this.searchCategory({
              where: {
                keyword: keyword ?? undefined,
                reportType: reportType as unknown as ReportType // TODO: change to string
              }
            }).pipe(
              catchError((error) => {
                // eslint-disable-next-line no-console
                console.error('Error in combined category', error);
                return of({ count: 0, results: [] });
              })
            ),
            this.searchReport({
              where: {
                keyword: keyword ?? undefined,
                profileId: this.session.getProfile()?.id,
                reportType: reportType as unknown as ReportType // TODO: change to string
              }
            }).pipe(
              catchError((error) => {
                // eslint-disable-next-line no-console
                console.error('Error in combined trait', error);
                return of({ count: 0, results: [] });
              })
            )
          ]).pipe(
            mergeMap(([category, trait]) =>
              of(
                ReportViewSearchActions.updateCategory({
                  count: category.count,
                  results: category.results
                }),
                ReportViewSearchActions.updateTrait({
                  count: trait.count,
                  results: trait.results
                }),
                ReportViewSearchActions.updateLoading({ loading: false })
              )
            ),
            catchError((error) => {
              // eslint-disable-next-line no-console
              console.error('onFetchCategoryAndTrait', error);
              return of(
                ReportViewSearchActions.updateCategory({
                  count: 0,
                  results: []
                }),
                ReportViewSearchActions.updateTrait({
                  count: 0,
                  results: []
                }),
                ReportViewSearchActions.updateLoading({ loading: false })
              );
            }),
            startWith(ReportViewSearchActions.updateLoading({ loading: true }))
          );
        })
      );
    },
    { dispatch: true }
  );
}
